'use client';

import { ReactNode } from 'react';
import { useHomeContext } from '../HomeContext';
import { CountryConfig } from 'lib/region/getCountrySpecificConfig';
import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';
import { BuySectionInfo } from './BuySectionInfo';
import { useModal } from 'components/shared/Modal';
import { HomeUhxPricingModal } from 'components/shared/InfoModals/uhx';
import CartSummary from './CartOverview';
import UltrahumanXSection from './UhxSection';
import styles from './index.module.css';
// import { useHomeContext } from "../HomeContext";

type OffersDataType = {
  image?: string[];
  imageType?: 'circle' | 'square';
  title: ReactNode;
  onClick?: () => void;
  modal?: ReactNode;
};

interface HomeBuySectionProps {
  title: string;
  offersData?: OffersDataType[];
  secondaryOffersData?: OffersDataType[];
  defaultStrikedPrice?: boolean;
  defaultOfferText?: string;
  defaultOfferDiscount?: number | string;
  countrySpecificConfigData: CountryConfig;
}

const HomeBuySection: React.FC<HomeBuySectionProps> = ({
  title,
  defaultStrikedPrice = false,
  defaultOfferText,
  defaultOfferDiscount,
  countrySpecificConfigData,
}) => {
  const {
    uhx,
    store,
    uhxCart,
    setUhxCart,
    price,
    affiliateDiscount,
    referral,
    shippingEstimate,
    defaultCurrency,
    coverageRef,
    checkout,
  } = useHomeContext();
  const ModalClient = useModal();

  const openUhxInfoModal = () => {
    ModalClient.set(<HomeUhxPricingModal />);
    ModalClient.show();
  };

  const handleCheckout = () => {
    checkout();
    ModalClient.hide();
  };

  return (
    <div>
      <div className={styles.desktopBuySectionInfo}>
        <BuySectionInfo
          title={title}
          store={store as ShopifyStore}
          defaultCurrency={defaultCurrency}
          price={price}
          defaultStrikedPrice={defaultStrikedPrice}
          referral={referral}
          shippingEstimate={shippingEstimate}
          affiliateDiscount={affiliateDiscount}
          defaultOfferText={defaultOfferText}
          defaultOfferDiscount={defaultOfferDiscount}
          secondaryOfferData={countrySpecificConfigData?.secondaryOffers}
        />
      </div>
      {!uhx ? (
        <UltrahumanXSection
          uhx={uhx}
          uhxCart={uhxCart}
          setUhxCart={setUhxCart}
          store={store as ShopifyStore}
          ref={coverageRef}
          defaultCurrency={defaultCurrency}
          openUhxInfoModal={openUhxInfoModal}
        />
      ) : null}
      <CartSummary handleCheckout={handleCheckout} />
    </div>
  );
};

export default HomeBuySection;
